// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__1xHRs","container_goBack":"footer_container_goBack__Emg6u","goback":"footer_goback__6SflT","main":"footer_main__34YfB"};